import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCurrency'
})
export class FormatCurrencyPipe implements PipeTransform {

/*   formatCurrency(sum, frDigMin: number) {
    console.count('formatCurrency');
    if (sum) {
      return sum.toLocaleString('en-UK', {
        style: 'decimal',
        minimumFractionDigits: frDigMin,
        maximumFractionDigits: frDigMin
      });
    } else {
      return 0;
    }
  } */

  transform(sum: any, frDigMin: number): unknown {
    return !(sum === undefined) ? sum.toLocaleString('en-UK', {
      style: 'decimal',
      minimumFractionDigits: frDigMin,
      maximumFractionDigits: frDigMin
    }) : 0;
  }

}
